import React from "react";

export const PlusCircle = ({ color = "#706A85" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_51_4474)">
        <rect width="16" height="16" rx="8" fill="currentColor" />
        <path
          d="M8.66667 7.33333V4H7.33333V7.33333H4V8.66667H7.33333V12H8.66667V8.66667H12V7.33333H8.66667Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_51_4474">
          <rect width="16" height="16" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
